module.exports = __webpack_public_path__ + "img/open_button_text.67a20891.svg";